// extracted by mini-css-extract-plugin
module.exports = {"hidden":"termList_hidden__XbFBS","textEmphasis":"termList_textEmphasis__fNBHV","termsWrap":"termList_termsWrap__E2mde","all":"termList_all__rgvYu","label":"termList_label__S2Y7z"};